// extracted by mini-css-extract-plugin
export default {"tabs":"ResourcesBlackoutCard_tabs__ruNVQ","addButton":"ResourcesBlackoutCard_addButton__OEOZu"};